/*** IMPORTS FROM imports-loader ***/
(function() {

define([
  'jquery',
  'mustache',
  'pip-model',
  'plugin.tooltip',
  'pip-events',
  'pip-common.validate',
  'pip-common.utils'
],
  function attachLaborAddOn(
    $,
    Mustache,
    pip,
    tooltip,
    pipEvents,
    validate,
    utils
  ) {
    var viewModel = {
      isZipCodeValid: true,
      zipCode: null,
      addOns: null,
      getFormatPrice: function getFormatPrice(price) {
        var fullAmount = price && price.toFixed(2);
        var formattedPrice = {
          dollars: fullAmount.substring(0, fullAmount.length - 3),
          cents: fullAmount.substring(fullAmount.length - 2)
        };

        return formattedPrice;
      },
      setAttachLabor: function setAttachLabor() {
        pip.customer.attachLabor = {
          isOptedIn: viewModel.isOptedIn,
          itemId: pip.products.primary.data.itemId.toString()
        };
      },
      setInstallationSkuZipCode: function setInstallationSkuZipCode(zipCode) {
        pip.installationSku.zipCode = zipCode;
      },
      setInstallationSkuPrice: function setInstallationSkuPrice(price) {
        pip.installationSku.installRetailPrice.formattedPrice = price;
      },
      setZipCode: function setZipCode(zipCode) {
        viewModel.zipCode = zipCode;
      },
      setValid: function setValid(isValid) {
        viewModel.isZipCodeValid = !!isValid;
      },
      setAddOns: function setAddOns(addOns) {
        viewModel.addOns = addOns;
      },
      init: function init(addOns) {
        viewModel.isOptedIn = false;
        viewModel.setAttachLabor();
        if (shouldZipBeDisplayed()) {
          viewModel.setAddOns(addOns);
          viewModel.setInstallationSkuZipCode(viewModel.zipCode ? viewModel.zipCode : pip.customer.dynamicEtaZipCode);
          viewModel.setInstallationSkuPrice(viewModel.getFormatPrice(pip.installationSku.installRetailPrice.price));
        }
      }
    }
    var view = {
      selectors: {
        checkbox: '#attach-labor__checkbox',
        whatToExpect: '.buybox__attach-labor .buybox__add-on__learn-more-cta',
        addOnContainer: '#add-on__container',
        multiAddOnContainer: '.multi-add-on__container',
        zipCodeContainer: '#zip-code-add-on__zip-code-container',
        priceContainer: '#zip-code-add-on__price-container',
        editButton: '#attach-labor-zip-code-edit-bttn',
        zipCodeForm: '#attach-labor-edit-zip-code-form',
        zipCodeInput: '#zip-code-add-on__input',
        warningMessage: '#attach-labor-zip-code-warning-message'
      },
      templates: {
        addOn: document.getElementById('attach-labor-add-on-template') && document.getElementById('attach-labor-add-on-template').innerHTML,
        multiAddOn: document.getElementById('attach-labor-multi-add-on-template') && document.getElementById('attach-labor-multi-add-on-template').innerHTML,
        tooltip: document.getElementById('attach-labor-tooltip-template') && document.getElementById('attach-labor-tooltip-template').innerHTML,
        addonWithZipCode: document.getElementById('attach-labor-add-on-zip-code-template') && document.getElementById('attach-labor-add-on-zip-code-template').innerHTML,
        zipCodeDefault: document.getElementById('attach-labor-addon-with-zip-code-default') && document.getElementById('attach-labor-addon-with-zip-code-default').innerHTML,
        zipCodePrice: document.getElementById('attach-labor-addon-with-zip-code-price') && document.getElementById('attach-labor-addon-with-zip-code-price').innerHTML,
        multiAddOnZipCode: document.getElementById('attach-labor-multiadd-on-zip-code-template') && document.getElementById('attach-labor-multiadd-on-zip-code-template').innerHTML,
        zipCodeFormContainer: document.getElementById('attach-labor-edit-zip-code-form-container') && document.getElementById('attach-labor-edit-zip-code-form-container').innerHTML
      },
      determineTemplates: function determineTemplates(addOns) {
        this.activeTemplate = view.templates.addOn
        this.container = view.selectors.addOnContainer

        if (addOns && addOns.multipleAddOns && addOns.side) {
          this.activeTemplate = view.templates.multiAddOn
          this.container = '#multi-add-on-' + addOns.side
        }
      },
      determineZipCodeTemplate: function determineZipCodeTemplate() {
        view.activeTemplate = view.templates.addonWithZipCode
        view.container = view.selectors.addOnContainer

        if (viewModel.addOns && viewModel.addOns.multipleAddOns && viewModel.addOns.side) {
          view.activeTemplate = view.templates.multiAddOnZipCode
          view.container = '#multi-add-on-' + viewModel.addOns.side
        }
      },
      initEventListeners: function initEventListeners() {

        var tooltipOptions = {
          type: 'click',
          position: 'bottom',
          content: Mustache.render(view.templates.tooltip, pip.installationSku),
          width: utils.getTooltipSize(),
          closeButton: true,
          bestPosition: false,
          closeOnClick: true
        };
        $(view.selectors.whatToExpect).tooltip(tooltipOptions);

        $(document).off('.attach-labor');
        $(document).on('click.attach-labor', view.selectors.checkbox, function () {
          viewModel.isOptedIn = $(this).is(':checked')
          var tooltipState = viewModel.isOptedIn ? 'open' : 'close';
          $(view.selectors.whatToExpect).tooltip(tooltipState);
          viewModel.setAttachLabor();
          pipEvents.attachLabor.attachLaborOptInStateChanged.trigger();
        })

        pipEvents.attachLabor.installationOptionsAtcClicked.off('.installationOptionsAtc');
        pipEvents.attachLabor.installationOptionsAtcClicked.on('.installationOptionsAtc', function () {
          viewModel.isOptedIn = true
          $(view.selectors.checkbox).prop('checked', viewModel.isOptedIn);
          viewModel.setAttachLabor()
        });

        pipEvents.attachLabor.attachLaborOptInStateChanged.off('.attachLaborStateChanged');
        pipEvents.attachLabor.attachLaborOptInStateChanged.on('.attachLaborStateChanged', function (e) {
          $(view.selectors.checkbox).prop('checked', pip.customer.attachLabor.isOptedIn);
        });

        $(document).on('click.attach-labor', view.selectors.editButton, function () {
          viewModel.setValid(false);
          viewModel.isOptedIn = false;
          viewModel.setAttachLabor();
          $(view.selectors.checkbox).prop({
            checked: false,
            disabled: true
          })
          view.updateDOM.zipCodeContainer()
        })

        $(document).on('input.attach-labor', view.selectors.zipCodeInput, function () {
          this.value = this.value.replace(/[^0-9]/g, '');
        })

        $(document).on('submit.attach-labor', view.selectors.zipCodeForm, function (e) {
          e.preventDefault()

          var formValues = $(this).serializeArray();
          var zipCode = formValues[0].value;

          viewModel.setValid(validate.validateZipCode(zipCode));

          if (viewModel.isZipCodeValid) {
            viewModel.setZipCode(zipCode);
            pipEvents.attachLabor.zipCodeChanged.trigger(viewModel.zipCode);
          }

          view.toggleWarningMessage(viewModel.isZipCodeValid);
        })

        pipEvents.attachLabor.newZipCodeProcessed.off('.attach-labor-newZipCodeProcessed');
        pipEvents.attachLabor.newZipCodeProcessed.on('.attach-labor-newZipCodeProcessed', function (event, homeServicesAddOnAvailability) {
          if (homeServicesAddOnAvailability.isAvailable) {
            viewModel.init(viewModel.addOns);
            view.init();
          }

          view.toggleWarningMessage(homeServicesAddOnAvailability.isAvailable);
        })

      },
      toggleWarningMessage: function toggleWarningMessage(hide) {
        $(view.selectors.warningMessage).toggleClass('u--hide', hide)
      },
      render: {
        activeTemplate: function activeTemplate() {
          return Mustache.render(view.activeTemplate, pip.installationSku);
        },
        zipCodeDefault: function zipCodeDefault() {
          return Mustache.render(view.templates.zipCodeDefault, pip.installationSku)
        },
        zipCodePrice: function zipCodePrice() {
          return Mustache.render(view.templates.zipCodePrice, pip.installationSku)
        }
      },
      updateDOM: {
        activeTemplate: function activeTemplate() {
          $(view.container).html(view.render.activeTemplate());
        },
        zipCodeContainer: function zipCodeContainer() {
          $(view.selectors.zipCodeContainer).html(view.getZipCodeElementMarkup());
        },
        priceContainer: function priceContainer() {
          $(view.selectors.priceContainer).html(view.render.zipCodePrice())
        }
      },
      getZipCodeElementMarkup: function getZipCodeElementMarkup() {
        if (viewModel.isZipCodeValid) {
          return view.render.zipCodeDefault()
        }
        return view.templates.zipCodeFormContainer;
      },
      init: function init() {
        view.determineZipCodeTemplate();
        view.updateDOM.activeTemplate();
        view.updateDOM.zipCodeContainer();
        view.updateDOM.priceContainer();
      }
    }

    function shouldZipBeDisplayed() {
      return !!(pip.features.attachLaborZipCodeEnabled && pip.customer.dynamicEtaZipCode);
    }

    return {
      init: function init(addOns) {
        if (shouldZipBeDisplayed()) {
          viewModel.init(addOns);
          view.init();
        }
        else {
          viewModel.init(); // If you dont send anything, will this break existing functionality?
          view.determineTemplates(addOns);
          document.querySelector(view.container).innerHTML = Mustache.render(view.activeTemplate, pip.installationSku);
        }
        view.initEventListeners();
      },
      view: view,
    }
  });

}.call(window));